import { UserStoreState } from '@models/UsersStoreState';
import { UsersClient } from '../clients/UserClient';
import { create } from 'zustand';

export const useUsersStore = create<UserStoreState>((set) => ({
  users: [],
  loading: true,
  error: null,
  getUsersByOrganization: async (organization: string) => {
    const users = await UsersClient.getUsersByOrganization(organization);
    set({ users });
  },
}));
